<template>
	<div class="main">
		<ul class="head">
			<li>{{device}}</li>
			<li>实时数据</li>
		</ul>
		<div class="contain">
			<el-row class="status">
				<el-col :span="4">设备连接状态 ：{{status}}</el-col>
				<el-col :span="2">csq : {{csq}}</el-col>
			</el-row>
			<div class="heart">
				<heart-rate></heart-rate>
			</div>
			<div class="breath">
				<breath-real></breath-real>
			</div>
		</div>
		
	</div>
</template>

<script>
	import heartRate from "./heart_rate.vue"
	import breathReal from "./breath_real.vue"
	export default {
		components:{
			heartRate,
			breathReal
		},
		data() {
			return {
				device:"",
				status:"脱离监护",
				csq:"13"
			}
		},
		created() {
			this.device=window.localStorage.getItem("deviceTime")
			window.console.log(this.device)
		},
		
		mounted() {
			
		},
			
	}
</script>

<style scoped="scoped">
	.main {
		width: 100%;
		height: 100vh;
		background: #F8F8FF;
	}

	.head {
		background: #fff;
		height: 60px;
		display: flex;
		list-style: none;
		border-bottom: 2px solid #e2e2f2;
		position: relative;
	}

	.head li {
		font-weight: bold;
		position: absolute;
	}

	.head li:first-of-type {
		font-size: 20px;
		left: 2%;
		top: 50%;
		color: #999;
		transform: translateY(-50%);
	}

	.head li:nth-of-type(2) {
		font-size: 24px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.contain {
		border: 2px solid #E6E6FF;
		background: #fff;
		width:95%;
		height: 80%;
		border-radius: 8px;
		margin: 20px auto 0;
		padding: 20px;
	}
	.heart,.breath{
		padding:16px 10px 0 10px;
		background: #FCFBFB;
		border-radius: 8px;
	}
	.breath{
		margin-top:40px;
	}
	.status{
		margin-bottom:20px;
	}
	.status .el-col{
		font-size:17px;
		color:#999;
		font-weight:bold;
	}
</style>
